import React from "react";
import loadable from "@loadable/component";
const ImageLoader = loadable(() => import("../../common/ImageLoader"));
import { REGION_FLAGS } from "../../../../shared/enums";
import { useIsMobile } from "../../../hooks";
import heroImage from "assets/images/landingAir/hero/uk-union-jack-lg.jpg";
import heroImageWebp from "assets/images/landingAir/hero/uk-union-jack-lg.jpg?as=webp";
import heroImageSm from "assets/images/landingAir/hero/uk-union-jack-sm.jpg";
import heroImageWebpSm from "assets/images/landingAir/hero/uk-union-jack-sm.jpg?as=webp";

function UnionJackHero() {
  const isMobile = useIsMobile(1024);

  return (
    <section className="hero-uk hero-uk--union-jack">
      <div className="container">
        <div className="hero-item">
          <div className="hero-item__content">
            <strong className="hero-item__subtitle">
              MILA AIR MINI COMES TO THE UK {REGION_FLAGS.GB}
            </strong>
            <h1 className="hero-item__title">
              Not the First Mini in a Union Jack
            </h1>
            <div className="hero-item__description">
              <p>
                And this one’s built to clean your air. Meet the Mila Air Mini –
                starting at just £199.
              </p>
            </div>
            <a
              href="https://buy.milacares.com/en-uk"
              className="hero-item__button button button--black"
              target="_blank"
              rel="noopener noreferrer"
            >
              Preorder Now
            </a>
          </div>
          <div className="hero-item__media">
            <ImageLoader
              className="hero-item__image img-relative"
              placeholderAspectRatio={1115 / 626}
              image={heroImage}
              webp={heroImageWebp}
              smallImage={heroImageSm}
              smallWebp={heroImageWebpSm}
              alt="The mila canada love - landing hero"
              noLazyLoad
              responsiveWidth={768}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default UnionJackHero;
